var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01872 4.31138C6.82259 4.11699 6.50601 4.1184 6.31162 4.31453C6.11723 4.51066 6.11864 4.82724 6.31478 5.02163L7.49009 6.1865C7.96708 6.65926 8.29429 6.98462 8.51569 7.26031C8.73075 7.5281 8.80453 7.70011 8.82417 7.85417C8.8365 7.9509 8.8365 8.04878 8.82417 8.14551C8.80453 8.29956 8.73075 8.47157 8.51569 8.73937C8.29429 9.01505 7.96708 9.34041 7.49009 9.81317L6.31478 10.978C6.11864 11.1724 6.11723 11.489 6.31162 11.6851C6.50601 11.8813 6.82259 11.8827 7.01872 11.6883L8.21521 10.5024C8.66586 10.0558 9.03417 9.69078 9.29538 9.36553C9.567 9.02731 9.76362 8.68402 9.81614 8.27194C9.83917 8.09126 9.83917 7.90841 9.81614 7.72773C9.76362 7.31565 9.567 6.97236 9.29538 6.63414C9.03417 6.30889 8.66586 5.94386 8.21521 5.49723L7.01872 4.31138Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.962e55fc4a9db54e520c45710fdf9f67.svg";
export { ForwardRef as ReactComponent };